import React, { useContext, useState } from 'react';

import { useLoaderData, useParams } from 'react-router-dom';

import { Handyman } from '@mui/icons-material';
import { Box, Button, IconButton } from '@mui/material';

import { CustomerRequestContext } from '../../context/CustomerRequest';
import Dialog from '../shared/Dialog';

const Debug = () => {
  const { customerInfo, setCustomerInfo } = useContext(CustomerRequestContext);
  const [debugOpen, setDebugOpen] = useState(false);

  const quoteData = useLoaderData() as any;
  const { step } = useParams();

  const toggleDebug = () => setDebugOpen(!debugOpen);

  const setTestingInfo = (template: string) => {
    switch (template) {
      case 'ld':
        setCustomerInfo({
          ...customerInfo,
          leadId: '2da56207-5db2-4c2a-a052-9493e5fced99',
          inventory: {
            ...customerInfo.inventory,
            rooms: {
              'living-room': 1,
              'primary-bedroom': 1,
              'guest-bedroom': 1,
              nursery: 0,
              office: 0,
              'bonus-room': 0,
              'kids-bedroom': 0,
              garage: 0,
              attic: 0,
              'storage-closet': 0,
              patio: 0,
              gym: 0,
              kitchen: 0,
              'dining-room': 0,
              laundry: 0,
            },
          },
          customer: {
            firstName: 'asdf',
            lastName: 'asdf',
            phone: '8885551234',
            email: 'asdf@test.com',
          },
          truck: true,
          locations: [
            {
              line_1: '1110 Market St',
              line_2: '',
              city: 'Chattanooga',
              state: 'TN',
              country: 'US',
              postal_code: '37402',
              timezone: 'America/New_York',
              propertyInfo: {
                stories: 1,
                elevator: 'FALSE',
                longWalkToTruck: false,
                type: 'SINGLE_FAMILY_HOME',
                area: 3500,
              },
              property_type: 'SINGLE_FAMILY_HOME',
              marketCode: 'CHATTANOOGA_TN',
            },
            {
              line_1: '237 Calhoun St',
              line_2: '',
              city: 'Cincinnati',
              state: 'OH',
              country: 'US',
              postal_code: '45219',
              propertyInfo: {
                stories: 1,
                elevator: 'FALSE',
                longWalkToTruck: false,
                type: 'SINGLE_FAMILY_HOME',
                area: 2000,
              },
              property_type: 'SINGLE_FAMILY_HOME',
              marketCode: 'CINCINATTI_OH',
            },
          ],
        });
        break;
      default:
    }
  };

  return (
    <>
      <Box position="fixed" left={60} bottom={20} zIndex={10000}>
        <IconButton onClick={toggleDebug}>
          <Handyman />
        </IconButton>
      </Box>
      {debugOpen ? (
        <Dialog open={debugOpen} onClose={toggleDebug} width={750}>
          <Box width={750}>
            <Button onClick={() => setTestingInfo('ld')}>LD Testing</Button>
            <div style={{ fontSize: 12, textAlign: 'left' }}>
              <pre>{`Step - ${step}`}</pre>
              <pre>{`$${quoteData?.totals?.total ? (quoteData.totals.total / 100).toFixed(2) : 0}`}</pre>
              <pre>{`${quoteData?.service_groups?.[0]?.services?.[0]?.quoted_workers} workers / ${quoteData?.service_groups?.[0]?.services[0].quoted_hours} hours`}</pre>
            </div>
            <h6>Customer Session Data</h6>
            <div style={{ fontSize: 12, textAlign: 'left' }}>
              <pre>{JSON.stringify(customerInfo.customer, null, 2)}</pre>
              <pre>{JSON.stringify(customerInfo.locations, null, 2)}</pre>
              <pre>{`date: ${JSON.stringify(customerInfo.date, null, 2)}`}</pre>
              <pre>{`time: ${JSON.stringify(customerInfo.time, null, 2)}`}</pre>
              <pre>{`truck: ${JSON.stringify(customerInfo.truck, null, 2)}`}</pre>
            </div>
          </Box>
        </Dialog>
      ) : null}
    </>
  );
};

export default Debug;
